/**
 * @generated SignedSource<<425c29957a9aa0fa4787939b5242d7bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSupportChat_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"initSupportChat_user">;
  readonly " $fragmentType": "useSupportChat_user";
};
export type useSupportChat_user$key = {
  readonly " $data"?: useSupportChat_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSupportChat_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSupportChat_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "initSupportChat_user",
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineDataFragmentSpread",
          "name": "initSierraChat_user",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "token",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emailToken",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sfChatToken",
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "0aa110fd664b961e260cb8ffa9285a59";

export default node;
